import { render } from "./RecurringServices.vue?vue&type=template&id=6c4eb786"
import script from "./RecurringServices.vue?vue&type=script&lang=js"
export * from "./RecurringServices.vue?vue&type=script&lang=js"

import "./RecurringServices.vue?vue&type=style&index=0&id=6c4eb786&lang=css"

import exportComponent from "D:\\MAMP\\htdocs\\electra\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__